var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 12.1569C10.5584 13.1852 9.01276 13.806 7.32377 13.806C3.55511 13.806 0.5 10.7154 0.5 6.90299C0.5 3.09057 3.55511 0 7.32377 0C9.01276 0 10.5584 0.620752 11.75 1.64903C12.9416 0.620752 14.4872 0 16.1762 0C19.9449 0 23 3.09057 23 6.90299C23 10.7154 19.9449 13.806 16.1762 13.806C14.4872 13.806 12.9416 13.1852 11.75 12.1569Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 12.1569C13.2172 10.8908 14.1475 9.0068 14.1475 6.90299C14.1475 4.79917 13.2172 2.91517 11.75 1.64903C12.9416 0.620752 14.4872 0 16.1762 0C19.9449 0 23 3.09057 23 6.90299C23 10.7154 19.9449 13.806 16.1762 13.806C14.4872 13.806 12.9416 13.1852 11.75 12.1569Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 1.64893C13.2172 2.91506 14.1476 4.79905 14.1476 6.90285C14.1476 9.00665 13.2172 10.8906 11.75 12.1568C10.2829 10.8906 9.35254 9.00665 9.35254 6.90285C9.35254 4.79905 10.2829 2.91506 11.75 1.64893Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f24f106e05ac8d66d6b8529628c9dfc3.svg";
export { ForwardRef as ReactComponent };